// A single source of truth for all tribute “sentiments”.
// You can reuse this anywhere (cards, banners, full pages, emails).

export const SENTIMENTS = {
  MEMORIAL: 'Memorial',
  BIRTHDAY: 'Birthday & Celebration',
  CONGRATS: 'Congrats & Praise',
  FAREWELL: 'Farewell',
  SYMPATHY: 'Sympathy & Get Well',
  THANK_YOU: 'Thank You',
  WELCOME: 'Welcome',
  SERVICE: 'Service Anniversary',
  EVENT: 'Event',
};

export const sentimentThemeMap = {
  [SENTIMENTS.MEMORIAL]: {
    key: 'memorial',
    iconClass: 'mdi mdi-flower-tulip-outline',
    headerBg: 'linear-gradient(135deg, #34495e 0%, #2c3e50 100%)',
    cardAccent: '#eaeff4',
    textColor: '#ffffff',
    badgeBg: '#95a5a6',
    badgeText: '#fff',
    borderColor: '#2c3e50',
    chip: { bg: '#ecf0f1', color: '#2c3e50' },
  },
  [SENTIMENTS.BIRTHDAY]: {
    key: 'birthday',
    iconClass: 'mdi mdi-cake-variant',
    headerBg: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
    cardAccent: '#fff1f5',
    textColor: '#3d0c11',
    badgeBg: '#ff7aa2',
    badgeText: '#fff',
    borderColor: '#ffd1e1',
    chip: { bg: '#ffe4ec', color: '#a61e4d' },
  },
  [SENTIMENTS.CONGRATS]: {
    key: 'congrats',
    iconClass: 'mdi mdi-trophy-outline',
    headerBg: 'linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%)',
    cardAccent: '#eef7fb',
    textColor: '#0b2e3b',
    badgeBg: '#2193b0',
    badgeText: '#fff',
    borderColor: '#a8d7e6',
    chip: { bg: '#d6eef6', color: '#0b2e3b' },
  },
  [SENTIMENTS.FAREWELL]: {
    key: 'farewell',
    iconClass: 'mdi mdi-airplane-takeoff',
    headerBg: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
    cardAccent: '#f1f7ff',
    textColor: '#102a43',
    badgeBg: '#4f86f7',
    badgeText: '#fff',
    borderColor: '#cfe0fc',
    chip: { bg: '#e8f0fe', color: '#1a3a73' },
  },
  [SENTIMENTS.SYMPATHY]: {
    key: 'sympathy',
    iconClass: 'mdi mdi-heart-half-full',
    headerBg: 'linear-gradient(135deg, #b2fefa 0%, #0ed2f7 100%)',
    cardAccent: '#ecfeff',
    textColor: '#063c4d',
    badgeBg: '#0ed2f7',
    badgeText: '#063c4d',
    borderColor: '#b6f3fb',
    chip: { bg: '#dff9fe', color: '#0b5367' },
  },
  [SENTIMENTS.THANK_YOU]: {
    key: 'thankyou',
    iconClass: 'mdi mdi-handshake-outline',
    headerBg: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
    cardAccent: '#fff7ea',
    textColor: '#4a2d12',
    badgeBg: '#f6ad55',
    badgeText: '#4a2d12',
    borderColor: '#ffe2b7',
    chip: { bg: '#ffe8c2', color: '#7a4419' },
  },
  [SENTIMENTS.WELCOME]: {
    key: 'welcome',
    iconClass: 'mdi mdi-hand-wave-outline',
    headerBg: 'linear-gradient(135deg, #a8ff78 0%, #78ffd6 100%)',
    cardAccent: '#ecfff7',
    textColor: '#03413a',
    badgeBg: '#26c485',
    badgeText: '#fff',
    borderColor: '#b9f3df',
    chip: { bg: '#d9fff0', color: '#036453' },
  },
  [SENTIMENTS.SERVICE]: {
    key: 'service',
    iconClass: 'mdi mdi-briefcase-check-outline',
    headerBg: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    cardAccent: '#fff5ed',
    textColor: '#442b1b',
    badgeBg: '#e68a57',
    badgeText: '#fff',
    borderColor: '#ffd8c7',
    chip: { bg: '#ffe6d7', color: '#6b3b21' },
  },
  [SENTIMENTS.EVENT]: {
    key: 'event',
    iconClass: 'mdi mdi-calendar-star',
    headerBg: 'linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)',
    cardAccent: '#f3ffe9',
    textColor: '#1e3a1c',
    badgeBg: '#58c472',
    badgeText: '#fff',
    borderColor: '#cdefc8',
    chip: { bg: '#e5f9d9', color: '#205b28' },
  },
};

export function getSentimentTheme(sentiment) {
  // Normalize & match
  const s = (sentiment || '').toLowerCase();
  const entry = Object.values(sentimentThemeMap).find((t) =>
    sentiment?.toLowerCase().includes(t.key)
  );
  // Loose fallback by label match
  if (!entry) {
    return (
      sentimentThemeMap[sentiment] || sentimentThemeMap[SENTIMENTS.MEMORIAL]
    );
  }
  return entry;
}
